import { render, staticRenderFns } from "./Agents.vue?vue&type=template&id=24683fdb&scoped=true&"
import script from "./Agents.vue?vue&type=script&lang=ts&"
export * from "./Agents.vue?vue&type=script&lang=ts&"
import style0 from "./Agents.vue?vue&type=style&index=0&id=24683fdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24683fdb",
  null
  
)

component.options.__file = "Agents.vue"
export default component.exports